import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { INotificationDelegate } from '../../../../../global/helpers/notification_delegate';
import { RouterHelper } from '../../../../../global/helpers/router_helper';
import {
  FeedbackSuggestedPlanModel,
  IFeedbackSuggestedPlanModel
} from '../../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { AdvisorHeaderDetailsQuery } from '../../../../../suggestions/components/plan_feedback/queries/advisor_plan_details_query';

class AdvisorBlockedHeader {
  private statusText = '';
  constructor(
    private ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery,
    ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
  ) {
    this.statusText = _4.toLower(ngFeedbackSuggestedPlanModel.read().previous_status || '');
  }
}

angular.module('capability-ng-academic-planner').component('advisorBlockedHeader', {
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_header/blocked_header.html',
  controller: AdvisorBlockedHeader
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/blocked_suggestions/components/blocked_header/blocked_header.ts